import React from "react";
import { Link } from "react-router-dom";
import { Calendar, User, ArrowRight } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import ContactCta from "../components/homi/ContactCta";
import { useContent } from "../context/ContentContext";

export default function BlogPage() {
  const { content } = useContent();
  const posts = content.blog || [];

  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title="News & Blog" crumb="Blog" subtitle="Tips, guides and stories from the EMB workshop and job sites." />

        <section className="py-20 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p) => (
              <Link to={`/homi/blog/${p.slug}`} key={p.slug} className="group rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <span className="inline-block bg-homi-gold/15 text-homi-goldDark text-xs font-heading font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-3">{p.category}</span>
                  <h3 className="font-heading font-bold text-xl text-homi-black mb-2 group-hover:text-homi-goldDark transition-colors">{p.title}</h3>
                  <p className="text-homi-body text-sm leading-relaxed mb-4">{p.excerpt}</p>
                  <div className="flex items-center gap-4 text-xs text-homi-body mb-4">
                    <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4 text-homi-goldDark" /> {p.date}</span>
                    <span className="flex items-center gap-1.5"><User className="w-4 h-4 text-homi-goldDark" /> {p.author}</span>
                  </div>
                  <span className="inline-flex items-center gap-2 font-heading font-bold text-homi-goldDark group-hover:gap-3 transition-all">Read More <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
